import { Box, Grid, Paper, Stack, Typography } from '@mui/material'
import CustomToolTip from '../../common/toolTip';
import custom from '../../../styles/mui/szVariables.json'

export default function CarbonSavingsCard({ id, content }: any) {

    return (
        <Paper id={id+'Savings'} elevation={0} sx={{ 
                    borderRadius: custom.corners6, 
                    mx: custom.spacing.sm,
                    mt: custom.spacing.sm,
                    p: custom.spacing.md,
                    width: "100%" }} >          
            <Grid container 
                    direction="column" 
                    justifyContent="start" 
                    alignItems="flex-left" 
                    display="flex" >
                <Grid item mb={custom.spacing.md}>
                    <Stack alignItems="center" 
                        direction="row" 
                        justifyContent="flex-end">
                        <Typography sx={{ 
                                color: 'text.secondary' 
                            }} 
                            variant="szHeading.Bold.xSmall" 
                            id={id+'SavingsTitle'}>
                                {content.monitorTitle}
                        </Typography>
                        <CustomToolTip message={content.toolTip} offset={[0,-10]}>
                            <Box component={"img"} id="tooltip"
                                ml="auto" 
                                p={custom.spacing.xxxs}    
                                alt="info icon"
                                src="/images/information.svg"
                            />
                        </CustomToolTip>
                    </Stack>
                </Grid>
                <Grid item mt={custom.spacing.lg}>
                    <Stack alignItems="center" direction="row" 
                        justifyContent="flex-end" >
                        <Box>
                            <Typography variant="szHeading.Bold.xLarge" 
                                id={id+'SavingsValue'}>
                                {content.value}
                                <Typography pl={'2px'} 
                                    sx={{ fontSize: '1rem', lineHeight: '125%'}} 
                                    variant="szHeading.Bold.Large" >
                                        {content.unit}
                                </Typography>
                            </Typography>
                            <Typography pt="3px" component={"p"} 
                                id={id+'SavingsDescription'}
                                variant="szHeading.Bold.xSmall" >
                                    {content.desc}
                            </Typography>
                        </Box>
                        <Box component={"img"} ml="auto" mr={2} p={"5px"}    
                                alt="Leaf icon"
                                src="/images/Leaf.svg"
                            /> 
                    </Stack>
                </Grid>
                <Grid item mt={custom.spacing.sm}
                            mb={custom.spacing.md}>
                    <Typography color="text.secondary" 
                        variant="szBody.Regular.Small"
                        id={id+'SavingsComments'}>
                       {content.comments}
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}